export default "__VITE_ASSET__BHQa$g$$__"